<form #form="ngForm" novalidate>
    <div class="row" *ngIf="entity">
        <div class="col-12">
            <!-- Pessoa Exterior -->
            <div class="row container-pessoa-exterior" *ngIf="podeCadastrarClienteExterior()">
                <div class="form-group col-12">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" [ngModel]="entity.exterior" (ngModelChange)="onChangeExterior($event)" name="exterior" id="exterior">
                        <label class="custom-control-label" for="exterior">Exterior?</label>
                    </div>
                    <p class="form-text text-muted form-text-codigo-integracao" *ngIf="isCliente()">
                        Marque esta opção se for um cliente do exterior
                    </p>
                    <p class="form-text text-muted form-text-codigo-integracao" *ngIf="isRepresentante()">
                        Marque esta opção se for um representante do exterior
                    </p>
                    <p class="form-text text-muted form-text-codigo-integracao" *ngIf="isTransportadora()">
                        Marque esta opção se for uma transportadora do exterior
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-12 col-md-4">
                    <label for="pessoaTipo" class="col-form-label">Tipo</label>
                    <select class="form-control" name="pessoaTipo" id="pessoaTipo" 
                        [ngModel]="entity.tipo || ''" (ngModelChange)="onChangeTipo($event ? $event : null)"
                        #pessoaTipo="ngModel" required="required"
                        [disabled]="!canEdit || !canEditTipo"
                        [autofocus]="!isTransportadora() && canEditTipo">
                        <option *ngFor="let tipo of tipos" [ngValue]="tipo.id">{{tipo.nome}}</option>
                    </select>
                    <sgt-form-control-error
                        *ngIf="pessoaTipo.errors && pessoaTipo.errors.required && pessoaTipo.dirty"
                        msgError="O tipo é obrigatório">
                    </sgt-form-control-error>
                </div>

                <div class="form-group col-12 col-md-4" *ngIf="isTipoPessoaFisicaOuJuridica()">
                    <label for="pessoaCnpjCpf" class="col-form-label">{{getLabelCnpjCpfByTipo()}}</label>
                    <div class="input-group">
                        
                        <div class="input-group-prepend" *ngIf="entity.identificadorMatrizFilial">
                            <sgt-identificador-matriz-filial-input-group-text
                                [identificador]="entity.identificadorMatrizFilial"
                                [prepend]="true">
                            </sgt-identificador-matriz-filial-input-group-text>
                        </div>
                        
                        <input type="text" class="form-control" [(ngModel)]="entity.cnpjCpf" name="pessoaCnpjCpf" id="pessoaCnpjCpf"
                            #pessoaCnpjCpf="ngModel" #cnpjCpfInput [required]="isCnpjCpfRequired()"
                            [ngControl]="pessoaCnpjCpf" [sgtCnpjCpf]="entity.tipo" [isValidate]="mustValidateCnpjCpf()" [isApplyMask]="!entity.exterior" (blur)="onBlurCnpjCpf()"
                            [disabled]="!canEditCnpjCpf || isConsultandoCnpj" [readonly]="!canEditCnpjCpf || isConsultandoCnpj">

                        <div class="input-group-append" *ngIf="isConsultandoCnpj">
                            <span class="input-group-text">
                                <i class='fas fa-spinner fa-pulse'></i> Consultando CNPJ
                            </span>
                        </div>
                    </div>
                    <label class="col-form-label ignorar-cnpj-cpf-invalido" *ngIf="usuarioPodeSalvarCnpjCpfInvalido">
                        <input type="checkbox" [(ngModel)]="ignorarCnpjCpfInvalido" name="ignorarCnpjCpfInvalido" id="ignorarCnpjCpfInvalido" tabindex="-1"
                            [disabled]="!canEditCnpjCpf" [readonly]="!canEditCnpjCpf"> Ignorar {{getLabelCnpjCpfByTipo()}} inválido
                    </label>

                    <sgt-form-control-error
                        *ngIf="pessoaCnpjCpf.errors && pessoaCnpjCpf.errors.required && pessoaCnpjCpf.dirty"
                        msgError="{{ 'O ' + (entity.tipo ? (isTipoPessoaFisica() ? 'CPF' : 'CNPJ') : 'CNPJ / CPF' ) + ' é obrigatório' }}">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="pessoaCnpjCpf.errors && pessoaCnpjCpf.errors.cnpjCpfInvalido"
                        msgError="{{ (isTipoPessoaFisica() ? 'CPF' : 'CNPJ') + ' inválido' }}">
                    </sgt-form-control-error>
                </div>              
            </div>            

            <!-- Situação Cadastral -->
            <div class="row" *ngIf="isTipoPessoaJuridica()">
                <div class="form-group col-12 col-md-6 col-xl-3">
                    <label for="empresaSituacaoCadastral" class="col-form-label">Situação Cadastral Empresa</label>
                    <input type="text" class="form-control text-center" [value]="entity.situacaoCadastral | empresaSituacaoCadastral" name="empresaSituacaoCadastral" id="empresaSituacaoCadastral"
                        disabled="disabled" readonly="readonly">                    
                    <p class="form-text text-muted">Situação da empresa junto à Receita Federal do Brasil (RFB)</p>                        
                </div>
                <div class="form-group col-12 col-md-6 col-xl-3">
                    <label for="empresaSituacaoCadastralData" class="col-form-label">Data Situação Cadastral</label>
                    <input type="text" class="form-control text-center" [value]="entity.situacaoCadastralData | date: 'dd/MM/yyyy'" name="empresaSituacaoCadastralData" id="empresaSituacaoCadastralData"
                        disabled="disabled" readonly="readonly">
                    <p class="form-text text-muted">Data da última atualização da situação cadastral</p>
                </div>   
                <div class="form-group col-12 col-md" *ngIf="entity.situacaoCadastralMotivoCodigo">
                    <label class="col-form-label">Motivo Situação Cadastral </label>
                    <div class="input-group">                        
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                {{entity.situacaoCadastralMotivoCodigo}}
                            </span>
                        </div>
                        <input type="text" class="form-control" [value]="entity.situacaoCadastralMotivoNome" name="empresaSituacaoCadastralMotivoNome" id="empresaSituacaoCadastralMotivoNome"
                            disabled="disabled" readonly="readonly">                                                                                                        
                    </div>
                    <p class="form-text text-muted">Motivo da situação cadastral</p>
                </div>                                
            </div>

            <div class="row">
                <div class="form-group col-12 col-md-2 col-xl">                 
                    <label for="pessoaCodigo" class="col-form-label">Código ERP</label>
                    <!-- Código Númerico -->
                     <!-- <input *ngIf="isShowCodigo()" type="number" class="form-control" [value]="entity.codigo" name="pessoaCodigo" id="pessoaCodigo"
                       disabled="disabled" readonly="readonly">  -->

                    <!-- Código Integração -->
                    <!-- Transportadora -->
                    <ng-template [ngIf]="isTransportadora()">
                        <input type="text" class="form-control" [(ngModel)]="entity.codigoIntegracaoErp" name="pessoaCodigo" id="pessoaCodigo"
                            #pessoaCodigo="ngModel" maxlength="50" [autofocus]="true" [disabled]="!canEdit" [readonly]="!canEdit">
                        <sgt-form-control-error
                            *ngIf="pessoaCodigo.errors && pessoaCodigo.errors.maxlength"
                            msgError="O código deve ter no máximo 50 caracteres">
                        </sgt-form-control-error>
                    </ng-template>

                    <!-- Demais tipos de pessoas -->
                    <ng-template [ngIf]="!isTransportadora()">
                        <input type="text" class="form-control" [value]="entity.codigoIntegracaoErp ? entity.codigoIntegracaoErp : null" name="pessoaCodigo" id="pessoaCodigo"
                            disabled="disabled" readonly="readonly">

                    </ng-template>
                </div>
                
                <!-- Cliente -->
                <ng-template [ngIf]="isCliente()">
                    <div class="form-group col-12 col-md-2 col-xl">
                        <label for="clienteCadastro" class="col-form-label">Cadastro</label>
                        <input type="text" class="form-control text-center" [value]="clienteCadastroLabel" name="clienteCadastro" id="clienteCadastro"
                            disabled="disabled" readonly="readonly">
                    </div>
                    <div class="form-group col-12 col-md-2 col-xl">
                        <label for="clienteSituacao" class="col-form-label">Situação</label>
                        <input type="text" class="form-control text-center" [value]="clienteSituacaoLabel" name="clienteSituacao" id="clienteSituacao"
                            disabled="disabled" readonly="readonly">                                               
                    </div>
                    
                    <!-- Dados do congelamento -->
                    <div class="col-12 mb-3" *ngIf="isClienteCongelado()">
                        <sgt-cliente-congelamento-card-info
                            [dataCongelamento]="clienteDataCongelamento"
                            [usuarioCongelamento]="clienteUsuarioCongelamento"
                            [motivoCongelamento]="clienteMotivoCongelamento"
                            [justificativaCongelamento]="clienteJustificativaCongelamento"
                            [isCollapseOpenedDefault]="false">
                        </sgt-cliente-congelamento-card-info>
                    </div>                     

                    <!-- Dados da Pré-Baixa -->
                    <div class="col-12 mb-3" *ngIf="isClientePreBaixado()">
                        <sgt-cliente-pre-baixa-card-info
                            [dataPreBaixa]="clienteDataPreBaixa"
                            [preBaixaManual]="clientePreBaixaManual"
                            [usuarioPreBaixa]="clienteUsuarioPreBaixa"
                            [motivoBaixa]="clienteMotivoBaixa"
                            [isCollapseOpenedDefault]="false">
                        </sgt-cliente-pre-baixa-card-info>
                    </div>                    
                    
                    <!-- Dados da Baixa -->
                    <div class="col-12 mb-3" *ngIf="isClienteBaixado()">
                        <sgt-cliente-baixa-card-info
                            [dataBaixa]="clienteDataBaixa"
                            [baixaManual]="clienteBaixaManual"
                            [usuarioBaixa]="clienteUsuarioBaixa"
                            [motivoBaixa]="clienteMotivoBaixa"
                            [isCollapseOpenedDefault]="false">
                        </sgt-cliente-baixa-card-info>
                    </div>
                </ng-template>

                <!-- Representante -->
                <ng-template [ngIf]="isRepresentante()">
                    <div class="form-group col-12 col-md">
                        <label for="representanteSituacao" class="col-form-label">Situação</label>
                        <select class="form-control" name="representanteSituacao" id="representanteSituacao" 
                            [ngModel]="representanteSituacao || ''" (ngModelChange)="onChangeRepresentanteSituacao($event ? $event : null)"
                            #representanteSituacaoModel="ngModel" required="isAdministrador" [disabled]="!canEdit || !isAdministrador">
                            <option value="">Selecione a situação...</option>
                            <option *ngFor="let situacao of representanteSituacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                        </select>  
                        <sgt-form-control-error
                            *ngIf="representanteSituacaoModel.errors && representanteSituacaoModel.errors.required && representanteSituacaoModel.dirty"
                            msgError="A situação é obrigatória">
                        </sgt-form-control-error>                                       
                    </div>                 
                </ng-template>

                <!-- Transportadora -->
                <ng-template [ngIf]="isTransportadora()">
                    <div class="form-group col-12 col-md">
                        <label for="transportadoraSituacao" class="col-form-label">Situação</label>
                        <select class="form-control" name="transportadoraSituacao" id="transportadoraSituacao" 
                            [ngModel]="transportadoraSituacao || ''" (ngModelChange)="onChangeTransportadoraSituacao($event ? $event : null)"
                            #transportadoraSituacaoModel="ngModel" required="required" [disabled]="!canEdit">
                            <option value="">Selecione a situação...</option>
                            <option *ngFor="let situacao of transportadoraSituacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                        </select>  
                        <sgt-form-control-error
                            *ngIf="transportadoraSituacaoModel.errors && transportadoraSituacaoModel.errors.required && transportadoraSituacaoModel.dirty"
                            msgError="A situação é obrigatória">
                        </sgt-form-control-error>                                       
                    </div>                     
                </ng-template>                              
            </div>
            <div class="row">
                <div class="form-group col-12 col-md">
                    <label for="dataCadastroInput" class="col-form-label">Data de Cadastro</label>
                    <input type="text" class="form-control text-center" [value]="dataCadastro | date: 'dd/MM/yyyy'" name="dataCadastroInput" id="dataCadastroInput"
                        disabled="disabled" readonly="readonly">                                                                                                        
                </div>
                <div class="form-group col-12 col-md">
                    <label for="dataFundacao" class="col-form-label">
                        <span *ngIf="isTipoPessoaFisica()">Data de Nascimento</span>
                        <span *ngIf="!isTipoPessoaFisica()">Data de Abertura</span>
                    </label>
                    <sgt-datepicker [(ngModel)]="entity.dataFundacao" name="dataFundacao" id="dataFundacao"
                        #dataFundacao="ngModel" [ngControl]="dataFundacao"
                        [disabled]="!canEdit" [readonly]="!canEdit" [required]="isDataFundacaoRequired">
                    </sgt-datepicker>
                    <sgt-form-control-error
                        *ngIf="dataFundacao.errors && dataFundacao.errors.required && dataFundacao.dirty"
                        msgError="A data de fundação é obrigatória">
                    </sgt-form-control-error>                                        
                </div>                
                <div class="form-group col-12 col-md" *ngIf="isShowUltimaRevisao()">
                    <label for="clienteDataUltimaRevisao" class="col-form-label">Última Revisão</label>
                    <ng-template [ngIf]="clienteDataUltimaRevisao">
                        <div title="Data da última revisão">
                            <i class="far fa-calendar-check"></i> {{clienteDataUltimaRevisao | date: 'dd/MM/yyyy'}} às {{clienteDataUltimaRevisao| date: 'HH:mm'}}
                        </div>
                        <div title="Responsável pela última revisão">
                            <i class="far fa-user"></i> {{clienteUsuarioUltimaRevisao?.nome}}
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="!clienteDataUltimaRevisao">
                        <p class="m-0">
                            <i class="far fa-calendar-times"></i> Nenhuma revisão realizada
                        </p>
                    </ng-template>                    
                    <!-- <input type="text" class="form-control text-center" value="{{clienteDataUltimaRevisao | date: 'dd/MM/yyyy'}} {{clienteDataUltimaRevisao ? ('às ' + (clienteDataUltimaRevisao | date: 'HH:mm')) : ''}}" name="clienteDataUltimaRevisao" id="clienteDataUltimaRevisao"
                        disabled="disabled" readonly="readonly">
                    <p class="form-text text-muted">
                        Responsável: {{clienteUsuarioUltimaRevisao?.nome}}
                    </p>                         -->
                </div>                                 
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="pessoaNome" class="col-form-label">
                        <span *ngIf="isTipoPessoaFisica()">Nome</span>
                        <span *ngIf="!isTipoPessoaFisica()">Razão Social</span>
                    </label>
                    <input type="text" class="form-control " [(ngModel)]="entity.nome" name="pessoaNome" id="pessoaNome"
                        #pessoaNome="ngModel" required="required" maxlength="255" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit" [autofocus]="!canEditTipo" #nomeInput>
                    <sgt-form-control-error
                        *ngIf="pessoaNome.errors && pessoaNome.errors.required && pessoaNome.dirty"
                        msgError="O nome é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="pessoaNome.errors && pessoaNome.errors.maxlength"
                        msgError="O nome deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="pessoaFantasia" class="col-form-label">
                        <span *ngIf="isTipoPessoaFisica()">Apelido</span>
                        <span *ngIf="!isTipoPessoaFisica()">Nome Fantasia</span>                        
                    </label>
                    <input type="text" class="form-control " [(ngModel)]="entity.nomeFantasia" name="pessoaFantasia" id="pessoaFantasia"
                        #pessoaFantasia="ngModel" maxlength="255" [required]="isNomeFantasiaRequired" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <sgt-form-control-error
                        *ngIf="pessoaFantasia.errors && pessoaFantasia.errors.required && pessoaFantasia.dirty"
                        msgError="O nome fantasia é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="pessoaFantasia.errors && pessoaFantasia.errors.maxlength"
                        msgError="O nome fantasia deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>

            <!-- Responsável -->
            <div class="row" *ngIf="isCliente() && isTipoPessoaJuridica()">
                <div class="form-group col-12 col-md-4">
                    <label for="pessoaCpfResponsavel" class="col-form-label">CPF do Responsável</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.cpfResponsavel" name="pessoaCpfResponsavel" id="pessoaCpfResponsavel"
                        #pessoaCpfResponsavel="ngModel" [sgtCnpjCpf]="1"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <sgt-form-control-error
                        *ngIf="pessoaCpfResponsavel.errors && pessoaCpfResponsavel.errors.cnpjCpfInvalido"
                        msgError="CPF do responsável inválido">
                    </sgt-form-control-error>                                            
                </div> 
                <div class="form-group col-12 col-md">
                    <label for="pessoaNomeResponsavel" class="col-form-label">Nome do Responsável</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.nomeResponsavel" name="pessoaNomeResponsavel" id="pessoaNomeResponsavel"
                        #pessoaNomeResponsavel="ngModel" [disabled]="!canEdit" [readonly]="!canEdit" maxlength="255" sgtUppercase>
                    <sgt-form-control-error
                        *ngIf="pessoaNomeResponsavel.errors && pessoaNomeResponsavel.errors.maxlength"
                        msgError="O nome do responsável deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>                        
                </div>                            
            </div>

            <div class="row" *ngIf="isTipoPessoaJuridica()">
                <!-- Porte Empresa -->
                <div class="form-group col-12 col-md">
                    <sgt-porte-empresa-form-control
                        [codigo]="entity.porteEmpresaCodigo"
                        [nome]="entity.porteEmpresaNome">
                    </sgt-porte-empresa-form-control>
                </div>

                <!-- Natureza Jurídica -->
                <div class="form-group col-12 col-md">
                    <sgt-natureza-juridica-form-control
                        [codigo]="entity.naturezaJuridicaCodigo"
                        [nome]="entity.naturezaJuridicaNome">
                    </sgt-natureza-juridica-form-control>
                </div>

            </div>
        </div>
    </div>
</form>
